import { render, staticRenderFns } from "./UnidentifiedReturnsList.vue?vue&type=template&id=665bb1eb&scoped=true"
import script from "./UnidentifiedReturnsList.vue?vue&type=script&lang=js"
export * from "./UnidentifiedReturnsList.vue?vue&type=script&lang=js"
import style0 from "./UnidentifiedReturnsList.vue?vue&type=style&index=0&id=665bb1eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665bb1eb",
  null
  
)

export default component.exports